import { NgModule } from '@angular/core';
import {DualPickListPipe} from './pipe/dual-pick-list.pipe';
import {FormsModule} from '@angular/forms';
import {BrowserModule} from '@angular/platform-browser';
import {PickListComponent} from './pick-list.component';
import {DualPickListComponent} from './dual-pick-list.component';
export class DualPickListModule { static decorators: DecoratorInvocation[] = [
{ type: NgModule, args: [{
    imports: [
        BrowserModule,
        FormsModule
    ],
    declarations: [
        PickListComponent,
        DualPickListPipe,
        DualPickListComponent

    ],
    exports:[
        DualPickListComponent,
        PickListComponent,
        DualPickListPipe
    ]
}, ] },
];
/**
 * @nocollapse
 */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
];
}

function DualPickListModule_tsickle_Closure_declarations() {
/** @type {?} */
DualPickListModule.decorators;
/**
 * @nocollapse
 * @type {?}
 */
DualPickListModule.ctorParameters;
}


interface DecoratorInvocation {
  type: Function;
  args?: any[];
}
